import React from 'react';

export const ErrorMessage = props => (
    <div>
        <p style={{ color: 'darkred', fontWeight: '700' }}>
            {
                (props.errors.code === 'auth/user-not-found' || props.errors.code === 'auth/wrong-password' || props.errors.code === 'auth/email-already-in-use') 
                ? 'Sorry, looks like there was a problem with the provided email or password.' 
                : ''
            }
            {
                (props.errors && props.errors.code !== 'auth/user-not-found' && props.errors.code !== 'auth/wrong-password' && props.errors.code !== 'auth/email-already-in-use') 
                ? props.errors.message 
                : ''
            }
        </p>
    </div>
);

// TODO: CONVERT TO STYLED COMPONENT


// WEBPACK FOOTER //
// ./src/js/components/Form/ErrorMessage.jsx